/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pos_Display_Sync_RetryInputs */

const vi_pos_display_sync_retry = /** @type {(inputs: Pos_Display_Sync_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đồng bộ lại màn hình khách`)
};

/**

* @param {Pos_Display_Sync_RetryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pos_display_sync_retry = /** @type {((inputs?: Pos_Display_Sync_RetryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pos_Display_Sync_RetryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pos_display_sync_retry(inputs)
});